import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import AddButton from "./add-user-button";
import ResearcherCard from "./card-item";

const styles = theme => ({
  root : {
    margin : 24
  },
  title: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  fab: {
    position: "absolute",
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  card: {
    marginTop: theme.spacing.unit * 2
  }
});

const ALL_RESEARCHERS = gql`
  query allResearchers {
    allResearchers {
      id
      name
      credentials
      descriptions
      photo
    }
  }
`;

class ResearchersDashboard extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="h5" component="h3" align="center">
          Investigadores
        </Typography>
        <Query query={ALL_RESEARCHERS}>
          {({ loading, error, data }) => {
            if (loading) return "Loading...";
            if (error) return `Error! ${error.message}`;
            const { allResearchers } = data;
            return (
              <Row>
                {allResearchers.map(row => (
                  <Col xs={12} md={6} key={row.id} className={classes.card}>
                    <ResearcherCard row={row} query={ALL_RESEARCHERS} />
                  </Col>
                ))}
              </Row>
            );
          }}
        </Query>
        <AddButton query={ALL_RESEARCHERS} />
      </div>
    );
  }
}

export default withStyles(styles)(ResearchersDashboard);



// WEBPACK FOOTER //
// ./src/components/researchers/index.js